import { render, staticRenderFns } from "./CommentDisplay.vue?vue&type=template&id=0723a9fb"
import script from "./CommentDisplay.vue?vue&type=script&lang=js"
export * from "./CommentDisplay.vue?vue&type=script&lang=js"
import style0 from "./CommentDisplay.vue?vue&type=style&index=0&id=0723a9fb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports